import { SVGPureIcon } from '@/ui';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo, useRef } from 'react';
import ErrorMask from '../components/error-mask';
import ImageCompareStack from '../components/image-compare-stack';
import ModifyImageInput from '../components/modify-image-input';
import { renderBlinkingDots } from '../render-dots';
import { getToolbarList, ModifyImageStore } from '../store';
import store from './store';
import { useState } from 'react';
import { Spin } from 'antd';
import ToolbarItem from '@/components/toolbar-item';
import appLogger from '@public/log/monitor';
import { zoomImg } from '@q/solib-utils';
import TaskLoading from '@/components/task-loading';

const ImageSharpenContent = () => {
  const {
    taskList,
    setActiveTask,
    activeTaskId,
    activeTask,
    hasMore,
    imageResult,
    loadMoreTasks,
    onRetry,
    taskListVisible,
    setTaskListVisible,
    deleteTaskItem,
    setSource,
    cancelTask,
    handleAction,
    setHistoryActiveTask,
  } = ModifyImageStore;

  const containerRef = useRef(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const handleBack = () => {
    if (activeTask) {
      setActiveTask(null, 'sharpen');
      setHistoryActiveTask('sharpen', null);
    } else {
      store.setImgUrl('');
    }
  };

  const onSubmit = () => {
    // setActiveTask(null, )
    store.submit();
  };
  const [imgSize, setImgSize] = useState({
    width: 0,
    height: 0,
  });

  const onImgLoaded = e => {
    const onResize = () => {
      if (!containerRef.current) {
        return;
      }
      const { offsetWidth, offsetHeight } = containerRef.current;
      const size = zoomImg(
        {
          type: 'contain',
          width: offsetWidth - 180,
          height: offsetHeight - 40,
        },
        {
          width: e.target.naturalWidth,
          height: e.target.naturalHeight,
        }
      );

      setImgSize({
        ...size,
      });
    };
    onResize();
    window.addEventListener('resize', onResize);
  };

  const barList = useMemo(
    () => getToolbarList().filter(item => item.action !== 'sharpen'),
    []
  );

  const resultImg = useMemo(() => {
    if (!imageResult) {
      return '';
    }
    const imgList = JSON.parse(imageResult?.out_images_w || '[]');
    if (!imgList.length) {
      return '';
    }
    return imgList[0].url;
  }, [imageResult]);

  useEffect(() => {
    if (!activeTask) {
      return;
    }

    let blinkingDotsRenderer = null;

    if ([1, 3].includes(activeTask.status)) {
      blinkingDotsRenderer = renderBlinkingDots();
    } else {
      blinkingDotsRenderer?.();
    }
    return () => {
      blinkingDotsRenderer?.();
    };
  }, [activeTask]);

  return (
    <div
      className=" modify-output size-full flex gap-24px items-center justify-end flex-col p-24px min-h-400px flex-1 pb-24px"
      style={{
        paddingBottom: activeTask ? '60px' : '24px',
      }}
    >
      <div
        className="relative flex flex-1 pt-50px h-0 w-full items-center justify-center"
        ref={containerRef}
      >
        <Spin
          className="!absolute inset-0 !flex items-center justify-center"
          size="large"
        />

        <div
          className="absolute left-0 top-0 z-10 flex items-center pl-6px w-64px h-30px rounded-6px border-1px border-[rgb(29,33,41,.1)] transition-colors duration-300 bg-white color-[#1D2129] text-14px cursor-pointer hover:bg-[#F2F4F6]"
          onClick={handleBack}
        >
          <SVGPureIcon name="aigc-back" size={20} />
          返回
        </div>
        <div className="relative flex items-center ">
          {/* 处理中 */}
          {activeTask?.status === 1 && (
            <div
              id="sharpenCanvasContainer"
              className="absolute inset-0 flex items-center justify-center  size-full m-auto backdrop-filter backdrop-blur-20px transition-opacity duration-300 opacity-1 "
            >
              <canvas
                id="sharpenCanvas"
                ref={canvasRef}
                className="w-full h-full"
              />
              <TaskLoading
                position={'aibot_photo_edit'}
                onOpenPaymentGateway={() => {
                  appLogger.log({
                    key: 'aibot_photo_edit',
                    arrt: 'upscale',
                    action: 'click',
                    type: 'open_member',
                    task_id: ModifyImageStore.activeTask?.biz_id,
                    work_id: JSON.parse(ModifyImageStore.activeTask?.data || '{}')?.id,
                  });
                }}
                type="image"
                taskInfo={activeTask}
                cancelTask={ModifyImageStore.cancelTask}
              />
            </div>
          )}

          {/* 处理异常 */}
          {activeTask?.status === 3 && <ErrorMask imageResult={imageResult} />}

          {/* 处理完成 */}
          {activeTask?.status === 2 && (
            <ImageCompareStack
              key={resultImg}
              beforeImg={store.imgUrl}
              afterImg={resultImg}
            />
          )}

          <img
            key={activeTask?.status}
            src={store.imgUrl}
            style={{
              width: imgSize.width + 'px',
              height: imgSize.height + 'px',
              opacity: imgSize.width ? '1' : '0',
            }}
            onLoad={onImgLoaded}
            className="max-h-full overflow-hidden"
          />
        </div>

        {activeTask?.status === 2 && (
          <div
            className="absolute top-20px right-[0px] flex flex-col items-center bg-[#fafafa] rounded-12px"
            style={{
              boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.08)',
            }}
          >
            <ToolbarItem
              icon="https://p2.ssl.qhimg.com/t110b9a9301d2f7003de9ad1413.png"
              title="变视频"
              onClick={() => {
                handleAction('toVideo');
              }}
            />
            {barList?.map((item, index) => (
              <ToolbarItem
                key={index}
                iconDom={
                  <SVGPureIcon
                    name={item.icon}
                    className="size-20px text-black"
                  />
                }
                title={item.title}
                onClick={() => {
                  handleAction(item.action);
                }}
              />
            ))}

            <div className="w-[60%] h-[1px] bg-[#E5E6EB] my-1"></div>
            <ToolbarItem
              iconDom={
                <SVGPureIcon
                  name="task-download-v1"
                  className="size-20px text-black"
                />
              }
              title="下载"
              onClick={() => {
                handleAction('download');
              }}
            />
          </div>
        )}
      </div>
      {!activeTask && (
        <ModifyImageInput
          imageUrl={store.imgUrl}
          loading={store.isLoading}
          updateImageUrl={url => {
            setActiveTask(null, 'sharpen');
            setHistoryActiveTask('sharpen', null);
            store.setImgUrl(url);
          }}
          text={'变清晰'}
          handleSubmit={onSubmit}
        />
      )}
    </div>
  );
};

export default observer(ImageSharpenContent);
